export const XSRF_HEADER_NAME = 'X-XSRF-TOKEN';
export const DEFAULT_XSRF_COOKIE_NAME = 'XSRF-TOKEN';

export function getXsrfCookieName() {
  const meta = document.head.querySelector('meta[name="xsrf-cookie-name"]');

  return meta?.content || DEFAULT_XSRF_COOKIE_NAME;
}

export function getXsrfAxiosConfig() {
  return {
    xsrfCookieName: getXsrfCookieName(),
    xsrfHeaderName: XSRF_HEADER_NAME,
  };
}
